import { roleType } from "../../../../../shared/enums/role";
var createAuthManagerSlice = function (set, _api) { return ({
    authenticated: false,
    currentRole: roleType.unauthorized,
    userName: roleType.unauthorized,
    userToken: roleType.unauthorized,
    userLoggin: roleType.unauthorized,
    sessionId: roleType.unauthorized,
    permissions: [],
    initAuth: function (action) { return getInitAuth(set, action); },
    setToken: function (token) {
        set(function () { return ({ userToken: token }); });
    },
    setUserRole: function (role) {
        set(function () { return ({ currentRole: role }); });
    },
    setPermissions: function (permissions) {
        set(function () { return ({ permissions: permissions }); });
    },
}); };
var getInitAuth = function (set, action) {
    set(function () { return ({ authenticated: true }); });
    if (action.userLoggin) {
        set(function () { return ({ userLoggin: action.userLoggin }); });
    }
    if (action.userName) {
        set(function () { return ({ userName: action.userName }); });
    }
    if (action.currentRole) {
        set(function () { return ({ currentRole: action.currentRole }); });
    }
    if (action.userToken) {
        set(function () { return ({ userToken: action.userToken }); });
    }
    if (action.userName) {
        set(function () { return ({ sessionId: action.userName }); });
    }
};
export default createAuthManagerSlice;
